<template>
    <section class="content">
        <div class="row">
            <div class="col-md-12">
                <macrotags-form :keyword="keyword" :disabled="disabled" @activate-mod="activateMod()"
                              @click="updateMacrotag()"
                              :showLabels="true"></macrotags-form>
            </div>
        </div>
    </section>
</template>

<script>
  import types from '../../store/mutation-types'
  import macrotagsApi from '../../api/macrotags'
  import macrotagsForm from './Form.vue'

  export default {

    components: {
      macrotagsForm
    },

    data () {
      return {
        keyword: false,
        disabled: true,
        interval: null
      }
    },

    beforeCreate () {
      macrotagsApi.show(this.$route.params.id)
        .then((response) => {
          this.keyword = response
        })
    },

    created () {
      this.$store.commit(types.SET_HEADER_STATE, {
        pageTitle: 'Macrotags inseriti',
        createButton: {
          display: true,
          text: 'Nuova keyword',
          to: '/keyword'
        }
      })
      this.interval = setInterval(() => {
        if (!this.disabled) {
          macrotagsApi.update(this.$route.params.id, this.keyword)
        }
      }, process.env.AUTOSAVE_TIMEOUT)
    },

    beforeDestroy () {
      clearInterval(this.interval)
    },

    methods: {
      activateMod () {
        this.disabled = !this.disabled
      },
      updateMacrotag () {
        this.loader = true
        return macrotagsApi.update(this.$route.params.id, this.keyword)
          .then((response) => {
            toastr.success('La keyword è stata salvata correttamente')
            this.loader = false
            this.disabled = true
          })
          .catch((response) => {
            this.loader = false
          })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/macrotags/Show.vue